import React, { useState } from "react";
import {
  Box,
  Typography,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Breadcrumbs,
  Link,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import VmMachine from '../assets/vm-symbol.png';
import disk from '../assets/disk.png';
import tags from '../assets/Tags.png';
import { useNavigate , useLocation} from 'react-router-dom';
import PropTypes from "prop-types";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
const ResourceDetailsLayout = ({
  selectedTab,
  setSelectedTab,
  children,
  resource,
  onCloseDrawer,
  isVMResizeEnabled,
  isResourceAddedFromCMP,
}) => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {resourceName } = location.state || {};
  



//   const allSections = [
//   { label: 'Overview', value: 0, icon: <img src={VmMachine} alt="VM" width={20} height={20} /> },
//   { label: 'Disk', value: 2, icon: <img src={disk} alt="VM" width={20} height={20} /> },
//     { label: 'Tags', value: 1, icon: <img src={tags} alt="VM" width={20} height={20} /> },
//         { label: 'Instance Resize', value: 3, icon: <img src={VmMachine} alt="VM" width={20} height={20} /> },


// ];


const allSections = [
    { label: 'Overview', value: 0, icon: <DashboardOutlinedIcon fontSize="small" /> },
    { label: 'Disk', value: 2, icon: <StorageOutlinedIcon fontSize="small" /> },
    { label: 'Tags', value: 1, icon: <LabelOutlinedIcon fontSize="small" /> },
    { label: 'Instance Resize', value: 3, icon: <ComputerOutlinedIcon fontSize="small" /> },
  ];
const sections = allSections.filter(section => {
  
  if (section.label === 'Disk' && 
      (
      resource?.resourceName === 'S3 bucket')) {
    return false;
  }
  if (section.label === 'Disk' && 
      (
     
   resource?.resourceName === 'Security Groups')) {
    return false;
  }
   if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'ALB')) {
    return false;
  }
  if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'RDS')) {
    return false;
  }
 if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'NLB')) {
    return false;
  }
if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'Route 53')) {
    return false;
  }
  if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'Resource Groups')) {
    return false;
  }
  if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'Virtual Machine')) {
    return false;
  }
  if (section.label === 'Disk' && 
      (
   resource?.resourceName === 'Storage Account')) {
    return false;
  }
  if (section.label === 'Tags' && 
      (
   resource?.resourceName === 'Route 53')) {
    return false;
  }
 
//    if (
//   section.label === "Instance Resize" &&
//   resource?.resourceName !== "EC2"
// ) {
//   return false;
// }
if (section.label === "Instance Resize") {
  return (
    resource?.resourceName === "EC2" &&
    isVMResizeEnabled &&
    isResourceAddedFromCMP
  );
}
  return true;
});

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
const selectedProvider =  localStorage.getItem('selectedProvider');


  return (
    <Box sx={{ height: "100vh", bgcolor: (t) => t.palette.mode === 'dark' ? 'background.default' : '#f4f7fa', padding: '0px', overflow:'hidden'}}>
      {/* 1. Top Bar */}
      <Box
        sx={{
          width: "100%",
          bgcolor: (t) => t.palette.mode === 'dark' ? 'background.paper' : '#fff',
          px: 2,
          py: 2, // Cleaned up duplicate py
          mt: 2,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ padding: "2px"}}>
            <img src={VmMachine} alt="VM" width={20} height={20}/>
          </Box>
          <Box sx={{ marginLeft: "8px" }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 300, color: "text.secondary", whiteSpace: "nowrap", fontSize: "18px", mb: 2 }}
            >
              <Box component="span" sx={{ color: "text.primary", fontWeight: 600, ml: 1, mr: 1 }}>
                {sections.find(section => section.value === selectedTab)?.label}
              </Box>
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", marginLeft: 5, fontWeight: 400, whiteSpace: "nowrap", fontSize: '14px', marginTop: -1 }}
          >
            { resource.resourceName || selectedProvider}  |  {[
              resource?.applicationName, 
              resource?.resource_Name || resource?.resourceNameConstraint 
            ].filter(Boolean).join("  |  ") || "Resource"}
          </Typography>
        </Box>
      </Box>

      {/* 2. Main Area: Sidebar + Main */}
      <Box sx={{ display: "flex", height: "calc(100vh - 100px)" }}>
        {/* Sidebar */}
        <Box
          sx={{
            width: 170,
            bgcolor: (t) => t.palette.mode === 'dark' ? 'background.paper' : '#fff',
            borderRight: 1,
            borderColor: 'divider',
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            overflowY: 'scroll',
          }}
        >
          <List dense>
            {sections.map((section, idx) => (
              <React.Fragment key={section.label}>
                <ListItemButton
                  selected={selectedTab === section.value}
                  onClick={() => setSelectedTab(section.value)}
                  sx={{
                    bgcolor: selectedTab === section.value 
                      ? ((t) => t.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.12)' : '#e5f1fb') 
                      : "transparent",
                    color: selectedTab === section.value 
                      ? ((t) => t.palette.mode === 'dark' ? '#90caf9' : '#2b61aa') 
                      : 'text.primary',
                    borderLeft: selectedTab === section.value
                      ? ((t) => `3px solid ${t.palette.mode === 'dark' ? '#90caf9' : '#2b61aa'}`)
                      : "3px solid transparent",
                    "&:hover": { 
                      bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.08)' : '#e5f1fb' 
                    },
                    py: 1,
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 32, color: 'inherit' }}>
                    {section.icon}
                  </ListItemIcon>
                  <ListItemText primary={section.label} />
                  {section.subMenu && (
                    <IconButton onClick={handleExpandClick} sx={{ color: 'inherit' }}>
                      {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                  )}
                </ListItemButton>
                {section.subMenu && (
                  <Collapse in={expanded} timeout="auto" unmountOnExit>
                    {section.subMenu.map((item) => (
                      <ListItemButton
                        key={item.label}
                        selected={selectedTab === item.value}
                        onClick={() => setSelectedTab(item.value)}
                        sx={{
                          bgcolor: selectedTab === item.value 
                            ? ((t) => t.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.12)' : '#e5f1fb') 
                            : "transparent",
                          color: selectedTab === item.value 
                            ? ((t) => t.palette.mode === 'dark' ? '#90caf9' : '#2b61aa') 
                            : 'text.primary',
                          borderLeft: selectedTab === item.value
                            ? ((t) => `3px solid ${t.palette.mode === 'dark' ? '#90caf9' : '#2b61aa'}`)
                            : "3px solid transparent",
                          "&:hover": { 
                            bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.08)' : '#e5f1fb' 
                          },
                          py: 1,
                          pl: 4, // Indent sub-menu items
                        }}
                      >
                        <ListItemText primary={item.label} />
                      </ListItemButton>
                    ))}
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>

        {/* Main content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            bgcolor: (t) => t.palette.mode === 'dark' ? 'background.paper' : '#fff',
            minWidth: 0,
          }}
        >
          {/* Main content children */}
          <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

ResourceDetailsLayout.propTypes = {
  selectedTab: PropTypes.number.isRequired, 
  setSelectedTab: PropTypes.func.isRequired, 
  children: PropTypes.node.isRequired,     
  resource: PropTypes.shape({        
    resourceName: PropTypes.string,
    applicationName: PropTypes.string,
    resource_Name: PropTypes.string,
    resourceNameConstraint: PropTypes.string,
  }),
  onCloseDrawer: PropTypes.func,        
};


export default ResourceDetailsLayout;

